module.exports = __webpack_public_path__ + "img/21.930982dd.png";